// class RequestParams {
//     constructor(urlParams, queryParams, headerParams) {
//         this.params = params;
//         Object.keys(params)
//             .forEach(key => url.searchParams.append(key, params[key]));
//     }
// }
//
// class Endpoint extends URL{
//     constructor(base, queryParams=null, urlParamTemplate=null, urlParam=null) {
//         if (urlParamTemplate !== null) { base = base.replace(urlParamTemplate, urlParam); }
//         super(base)
//         if (queryParams !== null) {
//             Object.keys(queryParams).forEach(key => this.url.searchParams.append(key, params[key]));
//         }
//
//     }
// }
//
// class ProductReviewBase {
//     constructor(apiKey, queryParams=null, headerParams=null, urlParamTemplate=null, urlParam=null) {
//         // super();
//         this.endpoint = new Endpoint(
//             'https://reviews.hulkapps.com/api/public/v2/',
//             urlParamTemplate, urlParam, queryParams);
//
//         this.headers = new Map([headerParams]);
//         this.headers.set('Content-Type', 'application/json');
//         this.headers.set('Accept', 'application/json');
//         this.headers.set('Authorization', 'Bearer ' + apiKey);
//     }
//
//
//     get(url=this.endpoint, headers=this.headers){
//
//         return fetch(url, {
//             method: "GET", headers
//         }).then(response => response.json());
//     };
// }
//
// class ProductReviewList extends ProductReviewBase {
//     constructor(apiKey, shopify_customer_id, page=null, limit=10, customer_id=null) {
//         const queryParams = new Map([page]);
//         let headerParams = new Map();
//         headerParams.set('x-shopify-customer-id', shopify_customer_id);
//         super(apiKey, queryParams, headerParams);
//
//     }
// }
//
// x = new ProductReviewList('eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5Mjc4MTExZi05OTQ2LTQyZWUtOTc5Ny1mNmUzNGM4ZTRjMjciLCJqdGkiOiIxNzc3NjM0MDVlZTgwMjY0ZDdjY2Y0MjA3ZWJjN2JkMWU5NGI4Y2JiNDQxMmRlMWEzYTlhY2M4NDFlZmIzYWE0MWI1ZjA2YzBjMWQ5NDIyMCIsImlhdCI6MTcxNzkzNTg1MywibmJmIjoxNzE3OTM1ODUzLCJleHAiOjM2MTEzOTE4NTIsInN1YiI6IjM1NzYwIiwic2NvcGVzIjpbXX0.NljnJWw2DQgbL4Vaz5qVckucasYppE6pe8okC3Da8gfTi6_ZKotkIgOK1EOxicNE-CNpQmB_RKfPWVwHZvOgqQ',
//     7123754549342, {"product_id": "189090693164"}, null, {"customer_id": "7123754549342"})


// s = x.get()
// class ReviewsURL extends URL{
//     constructor(base, ...queryParams) {
//         super(base);
//
//
//         Object.keys(queryParams).forEach(key => this.url.searchParams.append(key, params[key]));
//     }
// }


// 'https://oy6igxzerl.execute-api.ap-southeast-2.amazonaws.com/testing'
// product_id=null, count=null, customer_id=null
// class ProductReviewsBase {
//     constructor(endpoint, api_key) {
//         // this.product_id = product_id;
//         // this.count = count;
//         // this.customer_id = customer_id;
//         this.endpoint = endpoint
//         this.headers = {
//             Authorization: 'Bearer ' + api_key,
//             Accept: 'application/json',
//             'Content-Type': 'application/json'
//         };
//
//     }
//
//     get(...queryParams) {
//         url = new URL(this.endpoint);
//         Object.keys(queryParams).forEach(key => url.searchParams.append(key, params[key]));
//         const options = {
//             method: 'GET',
//             headers: this.headers,
//         };
//         const req = new Request(url, options);
//         fetch(req)
//             .then((response) => {
//                 if (!response.ok) {
//                     throw new Error(`HTTP error! Status: ${response.status}`);
//                 }
//
//                 return response.blob();
//             })
//             .then((response) => {
//                 let results = response.json();
//             });
//         }
//     set(...bodyParams) {
//         url = new URL(this.endpoint);
//         const options = {
//             method: 'POST',
//             headers: this.headers,
//             body: bodyParams,
//         };
//         const req = new Request(url, options);
//         fetch(req)
//             .then((response) => {
//                 if (!response.ok) {
//                     throw new Error(`HTTP error! Status: ${response.status}`);
//                 }
//
//                 return response.blob();
//             })
//             .then((response) => {
//                 let results = response.json();
//             });
//         }
// }

function starRating(rating, parentBlockDiv) {
    // const starSvg = document.createElement('svg');
    // starSvg.setAttribute('aria-hidden', 'true');
    // starSvg.setAttribute('focusable', 'false');
    // starSvg.setAttribute('class', 'rating');
    const svgEl = parentBlockDiv.querySelector('svg');
    let useEl = parentBlockDiv.querySelector('use');

    for (let i = 0; i < rating; i++) {
        svgEl.appendChild(document.createElement('use'));
    }
    //     <svg aria-hidden="true" focusable="false" class="rating">
    //   <use xlink:href="#stars-full-star" />
    // </svg>
}


class ProductReview {
    constructor(data) {
        this.id = data.id;
        this.product_id = data.product_id;
        this.email = data.email;
        this.rating = data.rating;
        this.verified = data.verified;
        this.author = data.author;
        this.title = data.title;
        this.body = data.body;
        this.media = data.media;
        this.custom_fields = data.custom_fields;
        this.created_at =  new Date(data.created_at);
        this.updated_at = new Date(data.created_at);
        this.helpfuls = data.helpfuls;

        this.authorDiv = null;
        this.ratingDiv = null;
        this.titleDiv = null;
        this.bodyDiv = null;
        this.dateDiv = null;


    }

    // set rating(data) {
    //
    // }




    get dataStruct() {
        return {
            "@type": "Review",
            "author": {
                "@type": 'Person',
                "name": this.author
            },
            "datePublished": this.created_at,
            "reviewBody": this.body,
            "name": this.title,
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": this.rating.toFixed(1).toString(),
                "bestRating": "5"
            }
        }
    }

    set block(parentEl) {
        parentEl.querySelector('.product--review__author').innerHTML = this.author;
        parentEl.querySelector('.product--review__title').innerHTML = this.title;
        parentEl.querySelector('.product--review__body').innerHTML = this.body;
        // var date = new Date(this.created_at).toDateString();
        //     // .toLocaleString('en-GB', { timeZone: 'UTC' }, {'dateStyle': 'short'});
        parentEl.querySelector('.product--review__date').innerHTML = '-  ' + this.created_at.toLocaleDateString();
        // parentEl.querySelector('.product--review__rating').innerHTML = this.rating;
        parentEl.querySelector('span').style.setProperty('--rating', this.rating);
        parentEl.querySelector('span').style.setProperty('--rating-max', '5.0');
        parentEl.querySelector('span').style.setProperty('--rating-decimal', '1');

    }



}

if (!customElements.get('product-reviews')) {
    customElements.define('product-reviews',
        class ProductReviewsElement extends HTMLElement {
            constructor() {
                super();
                this.productId = this.dataset.productId;
                this.endpoint = 'https://oy6igxzerl.execute-api.ap-southeast-2.amazonaws.com/testing/product_reviews'
                this.reviewBlocks = [...this.querySelectorAll(`[data-name*="product-review-"]`),]

                this.headers = {
                    Authorization: 'x',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                };
                this.queryParams = {
                    product_id: this.productId
                }
                window.addEventListener('load', this.fetchProductReviews);
                this.fetchProductReviews();


            };


            populateReviewBlocks(){

            };

            createReviewBlock(){

            }

            parseReviewsList(text){
                const obj = JSON.parse(text);
            }

            async fetchProductReviews() {
                const options = {
                    method: 'GET',
                    headers: this.headers,
                };
                const url = new URL(`https://oy6igxzerl.execute-api.ap-southeast-2.amazonaws.com/testing/product_reviews?product_id=${this.productId}`);
                const req = new Request(url, options);
                const response = await fetch(req);
                response.ok;
                response.status;
                const text = await response.text();
                const reviewsData = JSON.parse(text).data;

                const reviews = reviewsData.map((item) => new ProductReview(item));
                for (let i = 0; i < reviews.length; i++) {
                    reviews[i].block = this.reviewBlocks[i];
                }
            }
        }
    );
}

window.addEventListener('DOMContentLoaded', () => {
    if (window.ProductReviewsElement) window.ProductReviewsElement();
});


